"use client";

import { useState } from "react";
import Image from "next/image";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@repo/ui/components/ui/accordion";
import { cn } from "@repo/ui/lib/utils";
import { useTranslations } from "next-intl";

export default function HowWorks() {
  const t = useTranslations();

  const howWorks = [
    {
      step: 1,
      image: "/how-works/1.png",
      title: t("Home.howWorks.item1.title"),
      description: t("Home.howWorks.item1.description"),
    },
    {
      step: 2,
      image: "/how-works/2.png",
      title: t("Home.howWorks.item2.title"),
      description: t("Home.howWorks.item2.description"),
    },
    {
      step: 3,
      image: "/how-works/3.png",
      title: t("Home.howWorks.item3.title"),
      description: t("Home.howWorks.item3.description"),
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 w-full mt-10">
        <div
          className={cn(
            "relative order-1 flex items-center justify-center bg-cover bg-center rounded-[50px]",
            "w-full h-auto lg:h-[560px] lg:w-[560px]",
            "bg-[url('/how-works/bg.png')]",
            "dark:bg-[url('/how-works/bg_dark.png')]",
          )}
        >
          <div className="z-0 absolute inset-0 bg-primary-white dark:bg-primary-black opacity-50 rounded-[50px]"></div>
          <div className="z-10 w-full h-auto p-10 lg:px-10 lg:py-30">
            <Image
              src={howWorks[activeIndex]?.image || ""}
              alt={howWorks[activeIndex]?.title || ""}
              width={800}
              height={600}
              className="rounded-lg"
            />
          </div>
        </div>

        <div className="order-2 lg:order-1 flex flex-col justify-center text-center lg:text-left">
          <Accordion type="single" collapsible defaultValue="item-1">
            {howWorks.map((item, index) => (
              <AccordionItem key={item.step} value={`item-${item.step}`}>
                <AccordionTrigger
                  onClick={() => setActiveIndex(index)}
                  showIcon={false}
                  className={cn(
                    "grid grid-cols-[60px_1fr] sm:grid-cols-[80px_1fr] gap-2 sm:gap-4 items-center no-underline hover:no-underline appearance-none",
                    {
                      "opacity-40": activeIndex !== index,
                    },
                  )}
                >
                  <div
                    className={cn(
                      "flex items-center justify-center rounded-full border-0",
                      "w-12 h-12 sm:w-20 sm:h-20",
                      "bg-primary-magenta text-primary-white dark:bg-primary-white dark:text-primary-magenta",
                    )}
                  >
                    <span className="text-2xl sm:text-4xl font-bold">
                      {item.step}
                    </span>
                  </div>

                  <div className="flex flex-col justify-center">
                    <h3
                      className={cn(
                        "font-semibold transition-all",
                        activeIndex === index
                          ? "text-2xl lg:text-4xl"
                          : "text-base lg:text-xl",
                      )}
                    >
                      {item.title}
                    </h3>
                  </div>
                </AccordionTrigger>

                <AccordionContent className="grid grid-cols-[60px_1fr] sm:grid-cols-[80px_1fr] gap-2 sm:gap-4">
                  <div></div>
                  <div>
                    <p className="text-lg text-left">{item.description}</p>
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
}
